export const FEATURE_FLAGS_CONTENT_ID = 'mw-engine-webapp-feature-flags';
